import { render, staticRenderFns } from "./StepSection.vue?vue&type=template&id=56c5a68e&scoped=true&"
import script from "./StepSection.vue?vue&type=script&lang=js&"
export * from "./StepSection.vue?vue&type=script&lang=js&"
import style0 from "./StepSection.vue?vue&type=style&index=0&id=56c5a68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5a68e",
  null
  
)

export default component.exports